export const colors: any = {
    red: {
      primary: '#ad2121',
      secondary: '#ad2121',
    },
    blue: {
      primary: '#1e90ff',
      secondary: '#1e90ff',
    },
    yellow: {
      primary: '#e3bc08',
      secondary: '#e3bc08',
    },

    green: {
      primary: '#3a9e36',
      secondary: '#3a9e36'
    },
    darkgreen: {
primary: '#1a4718',
secondary: '#1a4718'
    },

    lightgreen: {
      primary: '#7ade768',
      secondary: '#7ade768'
          },

          purple: {
            primary: '#8000ff',
            secondary: '#8000ff'
          },

          pink:{
            primary: '#f799f1',
            secondary: '#f799f1'
          },
          
          brown: {
            primary: '#80563b',
            secondary: '#80563b'
          },

          orange: {
            primary: '#fca903',
            secondary: '#fca903'
          },

          info: {
            primary: '#0590a6',
            secondary: '#0590a6'
          },

          lightgray: {
            primary: '#a9aba7',
            secondary: '#a9aba7'
          },

          darkgray: {
            primary: '#444543',
            secondary: '#444543'
          },

          brightblue: {
            
            primary: '#2141b5',
            secondary: '#2141b5'
          },

          coralred: {
            primary: '#e68585',
            secondary: '#e68585'
          },

          black: {
            primary: '#000000',
            secondary: '#000000'
          },


          purpleblue: {
            primary: '#7d90b5',
            secondary: '#7d90b5'
          },

          grayblue :{
            primary: '#5d85a3',
            secondary:'#5d85a3'
          

          },

          gunmetal:{
            primary:'#2C3539',
            secondary:'#2C3539',
          },

          lightorange:{
            primary:'#F7CF8D',
            secondary:'#F7CF8D',
          }


  };
  